import ErrorMessage from './error';
import HintMessage from './hint';

import type { MessageProps } from './message.types';

const Message = ({
  id,
  hint,
  error,
  limit,
  numberOfCharacters,
  disabled,
}: MessageProps) => {
  if (error && !disabled) {
    return <ErrorMessage id={id}>{error}</ErrorMessage>;
  }

  if (hint) {
    return (
      <HintMessage
        id={id}
        limit={limit}
        numberOfCharacters={numberOfCharacters}
        {...(disabled && { disabled })}
      >
        {hint}
      </HintMessage>
    );
  }

  return null;
};

export default Message;
